import type { EntityRef } from "types/common.types"
import type { DeviceGroupRef } from "types/group.types"

export type EntityPopupField = { label: string } & (
  | { type: "text"; value: string | string[] }
  | { type: "number"; value: number; unit?: string }
  | { type: "entity-link"; value: EntityRef[]; loading?: boolean }
  | { type: "chips"; value: DeviceGroupRef[] }
)

export const isFieldEmpty = (field: EntityPopupField): boolean => {
  switch (field.type) {
    case "text":
      return [field.value].flat().length === 0
    case "entity-link":
      return !field.loading && field.value.length === 0
    case "chips":
      return field.value.length === 0
    default:
      return false
  }
}

export const isMultiline = (field: EntityPopupField): boolean =>
  (field.type === "text" || field.type === "entity-link") &&
  [field.value].flat().length > 1
